export const parseToDollar = (
  value: bigint,
  dollarRate: bigint,
  decimals: number = 18
): bigint => {
  return (value * dollarRate) / BigInt(100000000) / BigInt(10 ** decimals);
};
